import React from 'react'
import Section from '../Section'

const Projects = () => {
  return (
    <Section>
      <div className='projects'>
        <h3 className='h3-1'>WO<span>RK</span></h3>
        <div className="project">
            <div className="line1 line">
                <div className="img_1"></div>

                <div className="img_2"></div>

                <div className="img_3"></div>
                <div className="img_4"></div>

                <div className="img_5"></div>
                <div className="img_6"></div>

                <div className="img_8"></div>
                <div className="img_10"></div>

                <div className="img_11"></div>
                <div className="img_12"></div>

                <div className="img_13"></div>
                <div className="img_14"></div>

                <div className="img_15"></div>
                <div className="img_16"></div>
            </div>
        </div>
      </div>
    </Section>
  )
}

export default Projects